import React from 'react';
import { SpaceBetween } from 'utils/style/extendable';
import {
  CollectionItem,
  CollectionContent,
} from 'containers/Profile/Panels/DocumentManager/styles';
import messages from './Messages';
import Icon from 'components/Icon';
import Button from 'components/Button';
import Input from 'components/Input';
import Select from '../../components/Select';
import { IOption } from '../../components/Select/Select';
import { ITagView, TagType } from 'store/providers/providerTypes';

interface IComponentProps {
  isTagExists: (tagTitle: string) => boolean;
  item: ITagView;
  mode: 'update' | 'create';
  onSubmitForm: (
    mode: 'update' | 'create',
    title: string,
    exists: boolean,
    titles?: string[],
    type?: TagType,
    order?: number
  ) => void;
  onCancel: (mode: 'update' | 'create') => void;
}

interface IComponentStates {
  disableSubmit: boolean;
  error: string;
  exists?: boolean;
  title: string;
  titles: IOption[];
  tagType: TagType;
  order: number;
}

class TagEditor extends React.PureComponent<IComponentProps, IComponentStates> {
  state: IComponentStates = {
    title: this.props.item.text,
    error: '',
    disableSubmit: false,
    titles: [],
    tagType: this.props.item.type || 'General',
    order: this.props.item.order || Number(this.props.item.id) || 0,
  };

  timer: any;

  handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearTimeout(this.timer);
    const value = e.target.value;
    this.setState({ title: value });
    if (value !== '') {
      this.timer = setTimeout(this.triggerSearch, 500);
    }
  };

  triggerSearch = () => {
    const exists = this.props.isTagExists(this.state.title);
    if (exists) {
      if (this.props.mode === 'update') {
        this.setState({
          exists,
          error: messages.couldNotRenameCauseItExists,
          disableSubmit: true,
        });
      } else {
        this.setState({ exists, error: messages.tagTitleExistsItWillMove });
      }
    } else {
      this.setState({ exists, error: '', disableSubmit: false });
    }
  };

  render() {
    const { mode } = this.props;
    const { titles, tagType, order } = this.state;
    return (
      <CollectionItem>
        <CollectionContent>
          {mode === 'update' ? (
            <div className="row no-margin">
              <Input
                id="title"
                type="text"
                required={true}
                value={this.state.title}
                onChange={this.handleChangeInput}
                autoComplete="off"
                label={messages.title}
                placeholder={messages.title}
              />
              {this.state.error !== '' && (
                <div className="row col 12">
                  <p className="red-text">
                    <Icon type={'info'} />
                    {this.state.error}
                  </p>
                </div>
              )}
              <Select
                onChangeValues={(v) => {
                  this.setState({
                    tagType: (v[0]?.value || 'General') as TagType,
                  });
                }}
                options={['General', 'Identification'].map((it) => ({
                  value: it,
                  label: messages[it],
                }))}
                values={[{ value: tagType, label: messages[tagType] }]}
              />
              <Input
                id={'message'}
                label={messages.order}
                type={'number'}
                value={order}
                onChange={(e) => {
                  this.setState({ order: Number(e.target.value) });
                }}
              />

              <SpaceBetween>
                <Button
                  onClick={() =>
                    this.props.onSubmitForm(
                      mode,
                      this.state.title,
                      !!this.state.exists,
                      undefined,
                      tagType,
                      order
                    )
                  }
                  loading={this.state.disableSubmit}
                  type="submit"
                  color="green"
                >
                  {messages.confirm}
                </Button>
                <Button onClick={() => this.props.onCancel(mode)} color="red">
                  {messages.cancel}
                </Button>
              </SpaceBetween>
            </div>
          ) : (
            <div className="row no-margin">
              <Select
                values={titles}
                options={[]}
                letAddChip={true}
                placeholder={messages.tagNames}
                multiChoice={true}
                onChangeValues={this.onAddTags}
              />

              {this.state.error !== '' && (
                <div className="row col 12">
                  <p className="red-text">
                    <Icon type={'info'} />
                    {this.state.error}
                  </p>
                </div>
              )}
              <SpaceBetween>
                <Button
                  onClick={() =>
                    this.props.onSubmitForm(
                      mode,
                      '',
                      !!this.state.exists,
                      this.state.titles.reduce((list, item) => {
                        list.push(item.label);
                        return list;
                      }, [] as string[]),
                      tagType
                    )
                  }
                  loading={this.state.disableSubmit}
                  type="submit"
                  color="green"
                >
                  {messages.confirm}
                </Button>
                <Button onClick={() => this.props.onCancel(mode)} color="red">
                  {messages.cancel}
                </Button>
              </SpaceBetween>
            </div>
          )}
        </CollectionContent>
      </CollectionItem>
    );
  }

  onAddTags = (values: IOption[]) => {
    this.setState({ titles: values });
  };
}

export default TagEditor;
